// Function used for limiting the input field of hourly pay rate to 2 decimals max
// Could be used on other fields where we need to limit the max ammout of decimals to 2
export const setNumberTo2DecimalsOnly = (value: string) => {
  // Regex that checks if the number has more than 2 decimals
  const hasMoreThanTwoDecimals = /^\d*(\.\d{3,})?$/

  if (hasMoreThanTwoDecimals.test(value)) {
    // Slice the string so we get the first 5 characters, 2 digits, a dot, 2 more digits(the decimals)
    const changedValue = value.slice(0, 5)
    return changedValue
  }
  return value
}
